import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IArticle } from 'src/app/xena-api/dtos';
import { IListOptionsFilter } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class ArticleService extends BaseService<IArticle, IListOptionsFilter> {

  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'Article');
  }

  byNumber(articleId: string): Observable<IArticle> {
    return this.xenaClient.get(`${this.buildUrl()}/ByNumber?articleNumber=${articleId}`);
  }
}
